import { Box, Flex, Text } from "@storyofams/react-ui";
import Link from "next/link";
import { InfoList } from "./InfoList";
import { Rating } from "./Rating";
import { TotalInfo } from "./TotalInfo";
interface IInstructions {
  [key: string]: string;
}
export const Header = ({
  recipe,
  setRating,
  bundleId,
  isDescription = false,
}) => {
  const instructions: IInstructions = {
    PrepTime: recipe.prep_time,
    TotalTime: recipe.total_time,
    yeld: `${recipe?.makes_quantity} ${recipe?.makes_uom?.text}`,
    recipe_price_uom: recipe?.contents_uom.text,
    PricePer: recipe?.makes_uom?.text,
    Niveau: recipe.difficulty.text,
    Houdbaarheid: recipe.best_before_date,
    component: "recipe_information",
  };
  const tags = Object.entries(recipe.tags).filter(([title, value]) => {
    if (title !== "created_at" && title !== "id" && value) return value;
    return false;
  });
  return (
    <>
      {!isDescription && (
        <>
          <Box>
            <Flex justifyContent={"space-between"} alignItems={"center"}>
              <Text
                fontSize={"12px"}
                fontWeight={500}
                letterSpacing={"0.1em"}
                fontFamily="DINPro"
                color="#767473"
              >
                RECEPT
              </Text>
              <Link href={`/recipes?category=${recipe.recipe_category?.id}`}>
                <Box
                  backgroundColor={"#C39A9133"}
                  px="6px"
                  cursor={"pointer"}
                  borderRadius={"6px"}
                  pt="2px"
                  pb="3px"
                >
                  <Text
                    letterSpacing={"0.1em"}
                    css={{ textTransform: "uppercase" }}
                    color={"#C39A91"}
                    fontFamily={"DINPro"}
                    fontSize={"12px"}
                    fontWeight={500}
                    lineHeight={"16.2px"}
                  >
                    {recipe.recipe_category?.category_name}
                  </Text>
                </Box>
              </Link>
            </Flex>

            <Text
              fontFamily={"DINpro"}
              fontSize={["40px", "56px"]}
              fontWeight={700}
              data-id={"title"}
              letterSpacing={"0.4px"}
              width={"100%"}
              mb={1}
              css={{ "overflow-wrap": "break-word", hyphens: "auto" }}
            >
              {recipe.title.text}
            </Text>
          </Box>
          <Rating
            id={recipe.id}
            recipe={recipe}
            setRating={setRating}
            frame={recipe.space_slug && recipe.post_slug}
          />
        </>
      )}
      <Box
        display={[isDescription ? "flex" : "none", "flex"]}
        flexDirection={"column"}
      >
        <Text
          fontSize="18px"
          lineHeight="25.2px"
          mb={["20px", 3]}
          color="#1D1D1BCC"
          dangerouslySetInnerHTML={{ __html: recipe.description.text }}
        />
        <Box
          display={"flex"}
          flexWrap={"wrap"}
          css={{ textTransform: "uppercase" }}
          fontSize="13px"
          lineHeight="15px"
          fontWeight={600}
          order={[0, 1]}
        >
          {tags.map(([title]) => (
            <Box
              mr="8px"
              fontFamily={"DINPro"}
              fontSize={"12px"}
              fontWeight={500}
              letterSpacing={"0.1em"}
              px="8px"
              py="4px"
              border="1px solid grey200"
              borderRadius="sm"
              key={title}
              mb={"10px"}
            >
              {title.replace(/_/g, " ")}
            </Box>
          ))}
        </Box>
        <Box display={["block", "none"]}>
          <InfoList
            order={[1, 0]}
            mt={["10px", 0]}
            mb={[0, "24px"]}
            content={instructions}
          />
        </Box>

        <TotalInfo
          order={2}
          id={recipe.id}
          bundleId={bundleId}
          recipe={recipe}
        />
      </Box>
    </>
  );
};
